import { ParameterDto, SampleDetailsDto } from '@src/types/types.ts';
import { ParameterDetailPopup } from '@components/atoms/ParameterDetailPopup.tsx';

export const AsbestosParameterInfoOverlay = ({
  onClose,
  pmId,
  sample,
}: {
  onClose: () => void;
  pmId: string | null;
  sample: SampleDetailsDto;
}) => {
  if (!pmId) {
    return null;
  }

  const parameterToShowInfo = sample.parameters.filter(
    (parameter) => parameter.pmId === pmId,
  )[0] as ParameterDto;

  return (
    <ParameterDetailPopup parameter={parameterToShowInfo} onClose={onClose} />
  );
};
